module.exports = __webpack_public_path__ + "img/alarm_off.9036d530.svg";